var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 664 367",
    width: 664,
    height: 367,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 144.000,123.125 C 144.320,139.130 144.000,139.125 144.000,155.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 144.000,155.125 C 144.529,189.240 143.320,189.130 142.000,223.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 142.000,223.125 C 138.466,256.189 139.529,256.240 134.000,289.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 134.000,289.125 C 133.255,325.851 130.466,315.189 126.000,341.125",
    strokeWidth: 1.13,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 126.000,341.125 C 116.274,336.769 123.755,345.851 115.000,329.125",
    strokeWidth: 2.456,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 115.000,329.125 C 113.011,301.978 110.774,303.769 115.000,275.125",
    strokeWidth: 1.5,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 115.000,275.125 C 113.813,246.268 117.011,247.978 123.000,221.125",
    strokeWidth: 1.425,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 123.000,221.125 C 133.304,191.759 132.813,194.268 153.000,171.125",
    strokeWidth: 1.313,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 153.000,171.125 C 177.165,146.343 175.304,147.759 207.000,133.125",
    strokeWidth: 1.154,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 207.000,133.125 C 258.216,113.208 256.165,111.343 311.000,101.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 311.000,101.125 C 342.007,96.147 341.216,94.208 373.000,95.125",
    strokeWidth: 1.204,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 373.000,95.125 C 389.455,93.173 387.507,94.647 402.000,98.125",
    strokeWidth: 1.666,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 402.000,98.125 C 410.309,103.219 408.455,100.673 411.000,110.125",
    strokeWidth: 2.374,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 411.000,110.125 C 412.204,125.717 412.309,123.219 406.000,138.125",
    strokeWidth: 2.119,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 406.000,138.125 C 395.102,160.489 395.704,158.717 378.000,176.125",
    strokeWidth: 1.579,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 378.000,176.125 C 358.427,192.257 360.102,192.489 336.000,202.125",
    strokeWidth: 1.431,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 336.000,202.125 C 307.779,215.871 308.427,214.257 278.000,220.125",
    strokeWidth: 1.24,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 278.000,220.125 C 236.673,225.436 237.779,225.871 196.000,222.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 196.000,222.125 C 149.857,218.086 150.673,218.436 106.000,206.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 106.000,206.125 C 71.847,196.636 72.857,197.086 42.000,180.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 42.000,180.125 C 20.995,169.545 24.847,170.636 12.000,154.125",
    strokeWidth: 1.383,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.000,154.125 C 8.086,140.329 6.995,145.545 14.000,132.125",
    strokeWidth: 1.949,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.000,132.125 C 26.153,115.720 23.586,118.829 43.000,111.125",
    strokeWidth: 2.118,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 43.000,111.125 C 88.970,102.002 86.653,99.220 135.000,99.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 135.000,99.125 C 154.116,97.184 152.970,98.002 171.000,103.125",
    strokeWidth: 1.424,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 171.000,103.125 C 209.432,117.144 208.116,116.184 243.000,137.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 243.000,137.125 C 251.686,144.012 251.432,142.144 255.000,153.125",
    strokeWidth: 1.766,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 255.000,153.125 C 265.985,171.171 259.686,166.012 259.000,181.125",
    strokeWidth: 1.994,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 259.000,181.125 C 238.235,198.508 245.985,199.671 215.000,210.125",
    strokeWidth: 1.46,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 215.000,210.125 C 202.264,215.105 203.235,216.008 189.000,216.125",
    strokeWidth: 1.861,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 189.000,216.125 C 136.985,219.361 137.264,220.105 85.000,220.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 85.000,220.125 C 68.872,220.166 68.985,220.361 53.000,218.125",
    strokeWidth: 1.453,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 53.000,218.125 C 15.000,215.339 33.872,215.666 15.000,211.125",
    strokeWidth: 1.629,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.000,211.125 C 33.674,203.603 15.000,206.839 53.000,201.125",
    strokeWidth: 2.231,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 53.000,201.125 C 73.273,199.578 72.674,198.603 93.000,201.125",
    strokeWidth: 1.754,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 93.000,201.125 C 99.399,201.674 98.773,201.578 104.000,205.125",
    strokeWidth: 2.624,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 104.000,205.125 C 117.430,213.265 115.399,213.674 125.000,225.125",
    strokeWidth: 2.154,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 125.000,225.125 C 131.536,238.235 132.430,236.765 134.000,252.125",
    strokeWidth: 2.118,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 134.000,252.125 C 135.309,269.612 137.036,269.235 136.000,287.125",
    strokeWidth: 1.967,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 136.000,287.125 C 135.477,307.716 136.809,307.612 137.000,328.125",
    strokeWidth: 1.879,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 137.000,328.125 C 138.838,341.154 137.977,341.216 141.000,354.125",
    strokeWidth: 2.046,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 141.000,354.125 C 140.087,361.741 141.838,359.154 143.000,364.125",
    strokeWidth: 2.893,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 143.000,364.125 C 147.971,365.021 145.587,366.241 152.000,363.125",
    strokeWidth: 3.797,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 152.000,363.125 C 166.087,357.635 164.971,357.021 177.000,348.125",
    strokeWidth: 2.324,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 177.000,348.125 C 200.940,326.328 201.087,327.135 222.000,302.125",
    strokeWidth: 1.432,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 222.000,302.125 C 233.556,286.970 234.440,287.828 244.000,271.125",
    strokeWidth: 1.633,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 244.000,271.125 C 249.250,260.575 248.056,264.970 251.000,258.125",
    strokeWidth: 2.364,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 251.000,258.125 C 249.659,261.048 251.750,257.075 249.000,264.125",
    strokeWidth: 3.753,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 249.000,264.125 C 248.000,268.107 248.159,268.048 248.000,272.125",
    strokeWidth: 3.744,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 248.000,272.125 C 248.346,281.637 248.000,281.607 249.000,291.125",
    strokeWidth: 2.836,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 249.000,291.125 C 249.079,296.215 249.346,296.137 250.000,301.125",
    strokeWidth: 3.243,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 250.000,301.125 C 249.929,306.711 250.579,304.215 252.000,307.125",
    strokeWidth: 3.757,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 252.000,307.125 C 256.671,305.849 254.929,307.711 260.000,303.125",
    strokeWidth: 4.694,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 260.000,303.125 C 261.761,300.757 262.171,301.349 263.000,298.125",
    strokeWidth: 4.279,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 263.000,298.125 C 265.515,292.131 265.761,292.257 268.000,286.125",
    strokeWidth: 3.452,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 268.000,286.125 C 271.742,277.715 271.515,277.631 275.000,269.125",
    strokeWidth: 2.822,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 275.000,269.125 C 276.896,259.580 277.242,263.215 279.000,257.125",
    strokeWidth: 3.093,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 279.000,257.125 C 280.350,259.524 279.896,256.080 281.000,262.125",
    strokeWidth: 4.253,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 281.000,262.125 C 281.789,267.674 282.350,267.524 283.000,273.125",
    strokeWidth: 3.673,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 283.000,273.125 C 282.988,277.538 283.789,276.674 285.000,280.125",
    strokeWidth: 3.855,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 285.000,280.125 C 287.383,281.951 286.488,282.038 290.000,282.125",
    strokeWidth: 4.48,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 290.000,282.125 C 295.056,281.949 294.883,282.451 300.000,281.125",
    strokeWidth: 3.71,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 300.000,281.125 C 304.966,277.861 304.056,280.449 308.000,279.125",
    strokeWidth: 3.764,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 308.000,279.125 C 311.558,282.372 310.966,280.361 312.000,286.125",
    strokeWidth: 4.46,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 312.000,286.125 C 310.000,291.136 312.558,290.872 310.000,296.125",
    strokeWidth: 3.69,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 310.000,296.125 C 309.935,301.289 310.000,300.636 312.000,305.125",
    strokeWidth: 3.604,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 312.000,305.125 C 314.179,308.356 313.435,307.789 317.000,309.125",
    strokeWidth: 3.928,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 317.000,309.125 C 320.158,309.158 319.679,309.856 323.000,308.125",
    strokeWidth: 4.03,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M 323.000,308.125 C 331.196,305.027 331.158,305.158 339.000,301.125",
    strokeWidth: 3.061,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M 339.000,301.125 C 352.380,294.750 352.196,294.527 365.000,287.125",
    strokeWidth: 2.212,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M 365.000,287.125 C 375.870,279.417 376.380,280.250 387.000,272.125",
    strokeWidth: 2.198,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M 387.000,272.125 C 392.243,267.121 390.370,269.917 394.000,268.125",
    strokeWidth: 3.09,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M 394.000,268.125 C 394.000,272.125 395.743,269.121 394.000,276.125",
    strokeWidth: 4.142,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M 394.000,276.125 C 393.195,281.756 394.000,281.625 394.000,287.125",
    strokeWidth: 3.664,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M 394.000,287.125 C 394.171,293.013 394.695,291.756 397.000,296.125",
    strokeWidth: 3.57,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M 397.000,296.125 C 400.508,298.330 399.171,298.513 404.000,298.125",
    strokeWidth: 4.293,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M 404.000,298.125 C 409.093,296.891 409.008,297.830 414.000,295.125",
    strokeWidth: 3.693,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M 414.000,295.125 C 421.454,292.000 421.593,292.391 429.000,289.125",
    strokeWidth: 3.018,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M 429.000,289.125 C 433.561,285.686 431.954,288.000 435.000,287.125",
    strokeWidth: 3.737,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M 435.000,287.125 C 435.115,291.698 437.061,289.186 436.000,296.125",
    strokeWidth: 4.342,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M 436.000,296.125 C 437.111,301.774 437.115,301.698 439.000,307.125",
    strokeWidth: 3.61,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M 439.000,307.125 C 439.602,311.207 440.111,310.274 442.000,313.125",
    strokeWidth: 3.85,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M 442.000,313.125 C 445.702,316.025 444.602,315.207 449.000,315.125",
    strokeWidth: 4.381,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M 449.000,315.125 C 457.076,312.019 456.702,313.025 464.000,307.125",
    strokeWidth: 3.287,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M 464.000,307.125 C 487.720,292.891 486.076,291.519 507.000,274.125",
    strokeWidth: 1.569,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M 507.000,274.125 C 524.177,254.969 525.220,256.391 539.000,234.125",
    strokeWidth: 1.493,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M 539.000,234.125 C 555.313,209.320 556.177,209.969 571.000,184.125",
    strokeWidth: 1.27,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M 571.000,184.125 C 589.496,156.918 588.313,156.320 605.000,128.125",
    strokeWidth: 1.149,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M 605.000,128.125 C 617.418,104.613 617.496,104.918 627.000,80.125",
    strokeWidth: 1.295,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M 627.000,80.125 C 631.326,62.832 630.918,70.113 632.000,59.125",
    strokeWidth: 1.945,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M 632.000,59.125 C 630.180,64.042 632.326,57.332 629.000,69.125",
    strokeWidth: 3.277,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M 629.000,69.125 C 623.616,92.047 623.680,92.042 619.000,115.125",
    strokeWidth: 1.847,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M 619.000,115.125 C 613.201,147.164 612.616,147.047 607.000,179.125",
    strokeWidth: 1.261,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M 607.000,179.125 C 598.653,213.903 600.201,214.164 593.000,249.125",
    strokeWidth: 1.13,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M 593.000,249.125 C 579.036,295.665 585.653,294.903 581.000,341.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.d15cce8b4e317c9ccde4d15951a29578.svg";
export { ForwardRef as ReactComponent };